module.exports = __webpack_public_path__ + "img/20.a60059a6.jpg";